// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__24bfP","radioRow":"SimpleQuestionBuilderModal_radioRow__2FAKS"};